import React from 'react';

import { Typography } from "@material-ui/core"

import Page from "../../Components/Page"
import Queerify from "../../Components/Queerify"

export default () => {
    return (
        <Page title="Queerify">
            <Typography color="textSecondary" gutterBottom>
                Hier könnt Ihr eure eigenen Fotos hochladen, mit einem Filter versehen und dann für verschiedene Social Media Plattformen runterladen.
            </Typography>
            <Queerify />
        </Page>
    )
}